import { Component, OnInit, ViewChild } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { DealerService } from "src/app/core/services/dealer.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { UserService } from "src/app/core/services/user.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { GenericLabelValue } from "src/app/shared/models/DTO/GenericLabelValue.dto";
import { FinanceIntegration } from "src/app/shared/models/enums/FinanceIntegration.enum";
import { OAuthIntegration } from "src/app/shared/models/oauth-integration";
import { ContractFinanceVenueCustomerListComponent } from "./contract-finance-venue-customer-list/contract-finance-venue-customer-list.component";

@Component({
	selector: "app-contract-finance-setup",
	templateUrl: "./contract-finance-setup.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class ContractFinanceSetupComponent implements OnInit {
	@ViewChild("ContractFinanceVenueCustomerListComponent") ContractFinanceVenueCustomerListComponent: ContractFinanceVenueCustomerListComponent;
	changesToSave: boolean = false;

	financeIntegrations: GenericLabelValue[] = [];

	integrationActive: boolean;

	oauthIntegration: OAuthIntegration;
	oauthFetched: boolean = false;

	selectedDealerKey: string;

	constructor(
		public app: AppService,
		public venueService: OOVenueService,
		public dealerService: DealerService,
		public userService: UserService,
		private focuslink: FocuslinkService
	) {}

	ngOnInit(): void {
		if (!this.userService.user) {
			this.userService.userSubscription.subscribe((user) => {
				if (user && user.role >= 5 && !this.dealerService.dealer.value.key && this.dealerService.dealerList.value.length === 0) {
					this.dealerService.dealerListGet();
				}
			});
		} else {
			if (
				this.userService.user &&
				this.userService.user.role >= 5 &&
				!this.dealerService.dealer.value.key &&
				this.dealerService.dealerList.value.length === 0
			) {
				this.dealerService.dealerListGet();
			}
		}

		this.dealerService.dealerList.subscribe((list) => {
			if (!this.dealerService.dealer.value.key && this.userService.user.role >= 5) {
				this.dealerService.initDealer(this.dealerService.dealerList.value[0].key);
			}
		});

		if (this.dealerService.dealer.value.key) {
			this.oauthConnectionGet();
		} else {
			this.dealerService.dealer.subscribe((dealer) => {
				console.log(`dealer data`);
				if (dealer.key) {
					this.oauthConnectionGet();
				}
			});
		}

		if (this.userService.user && !this.dealerService.dealer.value.key && this.userService.user?.dealerKey !== "0") {
			this.dealerService.initDealer(this.userService.user.dealerKey, this.userService.user.UserVenue);
		}

		Object.keys(FinanceIntegration).forEach((i) => {
			if (isNaN(+i)) {
				this.financeIntegrations.push({
					label: i,
					value: FinanceIntegration[i],
				});
			}
		});
	}

	async oauthConnectionGet() {
		let appId: string;
		switch (this.dealerService.dealer.value.financeIntegration) {
			case FinanceIntegration["Quickbooks Online"]: {
				appId = `quickbooks`;
				break;
			}
			case FinanceIntegration.Xero: {
				appId = `xero`;
				break;
			}
			default: {
				this.oauthFetched = true;
				return;
			}
		}

		const resp = await this.focuslink.oAuthTokenGet(appId, undefined, this.dealerService.dealer.value.key);
		this.oauthFetched = true;
		const oauthIntegrations: OAuthIntegration[] = resp.map((i) => new OAuthIntegration(i));
		this.integrationActive = true;

		if (oauthIntegrations.length > 0) {
			this.oauthIntegration = oauthIntegrations[0];
		}
	}

	onSave() {
		this.dealerService.saveDealer();
		this.ContractFinanceVenueCustomerListComponent.saveVenueChanges();
	}

	refreshConnection(source) {}
}
